import React, { useState, useEffect, useMemo } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { useSnackbar } from "notistack";
import api from "../../../api";
import { useQuery } from "@tanstack/react-query";
import { ClipLoader } from "react-spinners";
import NoData from "../../../components/NoData";
import { BiFilter } from "react-icons/bi";
import { MdMore } from "react-icons/md";
import { MotionValue } from "framer-motion";
import { TbDashboard } from "react-icons/tb";
import { Additem, MinusSquare } from "iconsax-react";

const LeaveBalance = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [page, setPage] = useState(1);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [pfNumber, setPfNumber] = useState("");
  const [userId, setUserId] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [daysRemaining, setDaysRemaing] = useState("");
  const [reason, setReason] = useState("");
  const [isDeductOpen, setIsDeductOpen]= useState(false)
  const itemsPerPage = 10;


  const closeDeductModal =()=> {
    setIsDeductOpen(false)
    setDaysRemaing("")
    setReason("")
    setUserId("")
 
  }

  async function staffOnLeave() {
    const response = await api.staffOnLeave();
    return response;
  }

  const { isLoading, data, refetch } = useQuery(
    ["staffOnLeave"],
    staffOnLeave,
    {
      refetchOnWindowFocus: "always",
    }
  );

  // Filter and paginate data on frontend
  const filteredData = useMemo(() => {
    if (!data?.users) return [];

    return data?.users?.filter((item) => {
      const matchesFirstName =
        !firstName ||
        item.first_name?.toLowerCase().includes(firstName.toLowerCase());
      const matchesLastName =
        !lastName ||
        item.last_name?.toLowerCase().includes(lastName.toLowerCase());
      const matchesPfNumber =
        !pfNumber ||
        item.staff_number?.toLowerCase().includes(pfNumber.toLowerCase());

      return matchesFirstName && matchesLastName && matchesPfNumber;
    });
  }, [data?.users, firstName, lastName, pfNumber]);

  const paginatedData = useMemo(() => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, page, itemsPerPage]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const totalItems = filteredData.length;
  const startItem = (page - 1) * itemsPerPage + 1;
  const endItem = Math.min(page * itemsPerPage, totalItems);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's zero-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  async function handleSubmit() {
    setLoading(true);
    if (!userId) {
      enqueueSnackbar("Please select a staff", { variant: "error" });
      return;
    }
    if (!userId) {
      enqueueSnackbar("Days Remaining is Empty", { variant: "error" });
      return;
    }

    try {
      const response = await api.recallStaff({
        staff_id: userId,
        leave_duration: daysRemaining,
        reason: reason,
      });
      closeSumbitModal();
      enqueueSnackbar("Staff Leave Recalled Successfully", {
        variant: "success",
      });
      setLoading(false);
      refetch();

    } catch (error) {
      console.log(error);
      closeSumbitModal();
      enqueueSnackbar(error.message, { variant: "error" });
      setLoading(false);
    }
  }

   async function handleDeduct() {
    setLoading(true);
    if (!userId) {
      enqueueSnackbar("Please select a staff", { variant: "error" });
      return;
    }
    if (!userId) {
      enqueueSnackbar("Number of days is Empty", { variant: "error" });
      return;
    }

    try {
      const response = await api.deductLeave({
        staff_id: userId,
        leave_duration: daysRemaining,
      });
      closeSumbitModal();
      enqueueSnackbar("Staff Leave Recalled Successfully", {
        variant: "success",
      });
      setLoading(false);
      refetch();
    } catch (error) {
      console.log(error);
      closeSumbitModal();
      enqueueSnackbar(error.message, { variant: "error" });
      setLoading(false);
    }
  }

  const handleSubmitModal = (id) => {
    setUserId(id);
    setIsOpen(true);
  };

   const handleDeductModal = (id) => {
    setUserId(id);
    setIsDeductOpen(true);
  };

  function closeSumbitModal() {
    setIsOpen(false);
  }

  return (
    <div className="md:p-[20px] p-[10px] bg-[#F2F2F2] min-h-screen">
      <div className="border-[0.2px] border-[#98a2b3] rounded-[8px] bg-[#984779]">
        <div className="h-full p-[16px] md:p-[20px] block md:flex justify-between items-center md:flex-wrap w-full">
          <div className="flex items-center gap-[16px]">
            <div className="flex items-center">
              <h3 className="text-[#fff] text-[14px] md:text-[14px] mb-0 xl:text-[16px] font-semibold leading-[24px]">
                Manage Leave Balance
              </h3>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-4 overflow-x-auto custom-scrollbar">
            <BiFilter color="white" size={20} />
            <input
              type="text"
              placeholder="First Name"
              className="w-full sm:w-[200px] h-[36px] bg-[#F9FAFB] px-2 py-[8px] text-[14px] text-[#344054] leading-[20px] placeholder:text-[#667185] placeholder:text-[12px] border border-[#D0D5DD] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-[#9326ae] focus:border-[#9326ae]"
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
                setPage(1);
              }}
            />
            <input
              type="text"
              placeholder="Last Name"
              className="w-full sm:w-[200px] h-[36px] bg-[#F9FAFB] px-2 py-[8px] text-[14px] text-[#344054] leading-[20px] placeholder:text-[#667185] placeholder:text-[12px] border border-[#D0D5DD] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-[#9326ae] focus:border-[#9326ae]"
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
                setPage(1);
              }}
            />
            <input
              type="text"
              placeholder="PF Number"
              className="w-full sm:w-[200px] h-[36px] bg-[#F9FAFB] px-2 py-[8px] text-[14px] text-[#344054] leading-[20px] placeholder:text-[#667185] placeholder:text-[12px] border border-[#D0D5DD] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-[#9326ae] focus:border-[#9326ae]"
              value={pfNumber}
              onChange={(e) => {
                setPfNumber(e.target.value);
                setPage(1);
              }}
            />
          </div>
        </div>
      </div>

      {/* Desktop Table View */}
      <div className="hidden md:block overflow-x-auto">
        <div className="sm:-mx-6 lg:-mx-8 mt-5">
          <div className="inline-block min-w-full sm:px-6 lg:px-8">
            <div className="overflow-x-auto rounded-lg">
              <table className="min-w-full mb-6 border-[0.8px] border-r-[0.8px] border-l-[0.8px] border-[#E4E7EC] rounded-lg">
                <thead className="bg-[#F9FAFB]">
                  <tr>
                    <th className="border-b-[0.8px] border-[#E4E7EC] py-[12px] px-3 text-[14px] md:text-[16px] text-[#98A2B3] font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]">
                      <div className="flex px-3 whitespace-nowrap gap-[6px] md:gap-[12px] items-center">
                        Staff Name
                      </div>
                    </th>
                    <th className="border-b-[0.8px] border-[#E4E7EC] py-[12px] px-3 text-[14px] md:text-[16px] text-[#98A2B3] font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]">
                      <div className="flex whitespace-nowrap gap-[6px] md:gap-[12px]">
                        Leave Balance
                      </div>
                    </th>
                    <th className="border-b-[0.8px] border-[#E4E7EC] py-[12px] px-3 text-[14px] md:text-[16px] text-[#98A2B3] font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]">
                      <div className="flex whitespace-nowrap gap-[6px] md:gap-[12px]">
                        Leave Type
                      </div>
                    </th>
                    <th className="border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3] font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]">
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Duration
                      </div>
                    </th>
                    <th className="border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3] font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]">
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Start Date
                      </div>
                    </th>
                    <th className="border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3] font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]">
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Status
                      </div>
                    </th>
                    <th className="border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3] font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]">
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Action
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading && (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        Loading....
                      </td>
                    </tr>
                  )}
                  {!isLoading && paginatedData.length === 0 && (
                    <tr>
                      <td colSpan="6">
                        <NoData />
                      </td>
                    </tr>
                  )}

                  {paginatedData.map((item) => (
                    <tr key={item.id} className="mb-2 hover:bg-light-gray">
                      <td className="whitespace-wrap py-[10px] bg-white px-3 border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left">
                        <div className="flex items-center gap-2">
                        
                          <div>
                            <p className="mb-0">
                              {item.first_name} {item.last_name}
                            </p>
                            <p className="text-xs text-gray-500">
                              {item.staff_number}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="whitespace-nowrap py-[10px] bg-white px-3 border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-center">
                        {item.leave_days || "N/A"}
                      </td>
                      <td className="whitespace-nowrap py-[10px] bg-white px-3 border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-center">
                        {item.leave_type || "N/A"}
                      </td>
                      <td className="whitespace-nowrap py-[10px] bg-white px-3 border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-center">
                        {item.leave_duration || "N/A"} days
                      </td>
                      <td className="whitespace-nowrap py-[10px] bg-white px-3 border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-center">
                        {item.start_date ? formatDate(item.start_date) : "N/A"}
                      </td>
                      <td className="whitespace-nowrap py-[10px] bg-white px-3 border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-center">
                        <button
                          className={`${
                            item.on_leave
                              ? "text-sm font-normal border p-1 px-2 rounded-lg text-[#FFA043] border-[#FFA043]"
                              : "text-sm font-normal border p-1 px-2 rounded-lg text-[#388B41] border-[#388B41]"
                          }`}
                        >
                          {item.on_leave ? "On Leave " : "Present"}
                        </button>
                      </td>
                      <td className="whitespace-nowrap py-[16px] bg-white px-3 border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#1A202C] font-medium text-center">
                       
                        <Menu>
                          <MenuButton as={Button} bg="none" size="sm">
                            <MdMore size="20" color="#98A2B3" />
                          </MenuButton>
                          <MenuList>
                            <MenuItem 
                           onClick={() => handleSubmitModal(item?.id)}
                            >
                              <Additem
                                size="16"
                                className="mr-2"
                              />
                              Add Leave Days
                            </MenuItem>

                              <MenuItem 
                             onClick={() => handleDeductModal(item?.id)}
                            >
                              <MinusSquare
                                size="16"
                                className="mr-2"
                              />
                              Deduct Leave Days
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Card View */}
      <div className="md:hidden mt-5 space-y-4">
        {isLoading && (
          <div className="text-center py-4 text-sm">Loading....</div>
        )}
        {!isLoading && paginatedData.length === 0 && <NoData />}

        {paginatedData.map((item) => (
          <div
            key={item.id}
            className="bg-white border border-[#E4E7EC] rounded-lg p-4 shadow-sm"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                
                <div>
                  <h3 className="font-semibold text-[#1A202C] text-sm">
                    {item.first_name} {item.last_name}
                  </h3>
                  <p className="text-xs text-[#667185]">{item.staff_number}</p>
                  <p className="text-xs text-[#667185]">
                    {item.leave_type || "N/A"}
                  </p>
                </div>
              </div>
              <button className="text-xs font-normal border px-2 py-1 rounded-lg text-[#FFA043] border-[#FFA043]">
                On Leave
              </button>
            </div>

            <div className="grid grid-cols-2 gap-3 text-xs mb-4">
              <div>
                <span className="font-medium text-[#98A2B3]">Duration:</span>
                <p className="text-[#667185]">
                  {item.leave_duration || "N/A"} days
                </p>
              </div>
              <div>
                <span className="font-medium text-[#98A2B3]">Start Date:</span>
                <p className="text-[#667185]">
                  {item.start_date ? formatDate(item.start_date) : "N/A"}
                </p>
              </div>
            </div>

            <div className="flex justify-end">

                 <Menu>
                          <MenuButton as={Button} bg="none" size="sm">
                            <MdMore size="20" color="#98A2B3" />
                          </MenuButton>
                          <MenuList>
                            <MenuItem 
                           onClick={() => handleSubmitModal(item?.id)}
                            >
                              <Additem
                                size="16"
                                className="mr-2"
                              />
                              Add Leave Days
                            </MenuItem>

                              <MenuItem 
                             onClick={() => handleDeductModal(item?.id)}
                            >
                              <MinusSquare
                                size="16"
                                className="mr-2"
                              />
                              Deduct Leave Days
                            </MenuItem>
                          </MenuList>
                        </Menu>
              
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      {totalItems > 0 && (
        <div className="px-4 py-4 border-t border-[#E4E7EC] bg-white mt-5">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-500 text-center sm:text-left">
              <span>
                Showing {startItem} - {endItem} of {totalItems} results
              </span>
              <span className="mx-2">|</span>
              <span>
                Page {page} of {totalPages}
              </span>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={page === 1}
                className="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
              >
                Prev
              </button>
              <button
                onClick={() => setPage((prev) => prev + 1)}
                disabled={page === totalPages}
                className="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal isOpen={isOpen} onClose={closeSumbitModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add to Leave Balance</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <label className="font-medium text-gray-700">
                  Leave Days 
                </label>
                <input
                  type="number"
                  value={daysRemaining}
                  onChange={(e) => setDaysRemaing(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#984779]"
                  placeholder="Enter number of days"
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="font-medium text-gray-700">
                  Reason for Addition
                </label>
                <textarea
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  className="w-full px-3 py-2 min-h-[120px] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#984779] resize-none"
                  placeholder="Enter reason for recalling staff from leave"
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="red"
              mr={3}
              onClick={handleSubmit}
              isLoading={Loading}
              loadingText="Processing..."
            >
             Add Leave 
            </Button>
            <Button variant="ghost" onClick={closeSumbitModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

       <Modal isOpen={isDeductOpen} onClose={closeDeductModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Deduct from Leave Balance</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <label className="font-medium text-gray-700">
                  Leave Days 
                </label>
                <input
                  type="number"
                  value={daysRemaining}
                  onChange={(e) => setDaysRemaing(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#984779]"
                  placeholder="Enter number of days"
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="font-medium text-gray-700">
                  Reason for Deduction
                </label>
                <textarea
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  className="w-full px-3 py-2 min-h-[120px] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#984779] resize-none"
                  placeholder="Enter reason for recalling staff from leave"
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="red"
              mr={3}
              onClick={handleDeduct}
              isLoading={Loading}
              loadingText="Processing..."
            >
             Deduct Leave 
            </Button>
            <Button variant="ghost" onClick={closeDeductModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default LeaveBalance;
